import {
  combine,
  withCallbacks,
  withContext,
  withMemo,
} from 'react-hooks-combine'
import { withRouter } from 'react-router-dom'

import { withTableController } from 'shared/hooks'
import { ServicesContext } from 'services/context'
import { athlete as athleteRoutes } from 'routes/route.map'

import AthleteOverviewComponent from './component'
import { createColumns } from './columns.description'

export const AthleteOverview = combine({
  hocs: [withRouter],
  hooks: [
    withTableController({ id: 'athlete-table' }),
    withContext(
      'athleteService',
      ServicesContext,
      ({ athleteService }) => athleteService
    ),
    withCallbacks(
      {
        getTrProps:
          (_state, { history }) =>
          (_state, rowInfo) => {
            const athleteId = rowInfo?.original?.id

            return {
              style: { cursor: 'pointer' },
              onClick() {
                history.push(athleteRoutes.view(athleteId))
              },
            }
          },

        loadAthletes:
          ({ athleteService }) =>
          (tableState, _table, search = '') =>
            athleteService.query({
              page: tableState.page,
              size: tableState.pageSize,
              name: search,
            }),

        onSearch:
          ({ table }) =>
          (query) => {
            table.search(query)
          },
      },
      []
    ),
    withMemo('columns', () => createColumns(), []),
  ],
})(AthleteOverviewComponent)
